import styled from 'styled-components';
import { windowMaxWidth, windowMinWidth } from './breakpoints';

const SettlementsWrapper = styled.div`
  background-color: var(--greyscale-white);
  border: 1px solid var(--greyscale-dark-white);
  flex: auto;
  padding: 20px 0;

  &:last-child {
    border-bottom-left-radius: var(--border-radius-regular);
    border-bottom-right-radius: var(--border-radius-regular);
  }
`;

const SettlementsListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin: 0 0 20px;
`;

const SettlementsListItemVerticalSectionWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 150px;

  @media ${windowMaxWidth.mobile} {
    min-width: 0;
  }
`;

const SettlementsListItemHorizontalSectionWrapper = styled.div`
  align-items: center;
  display: flex;
  flex: auto;
  flex-flow: row wrap;
  gap: 20px;
  position: relative;

  &.attachments-modal-list-item {
    margin-left: 10px;
    padding: 0;
  }
`;

const SettlementsListSmallSizeGreyTextWrapper = styled.span`
  align-items: center;
  color: var(--greyscale-shade);
  display: flex;
  font-size: var(--font-size-small);
  line-height: var(--font-line-height-small);

  &.attachments-modal-list-item {
    min-width: 225px;
  }
`;

const SettlementsListNormalSizeBoldTextWrapper = styled.div`
  color: ${(props) => (props.$placeholder ? 'var(--greyscale-concrete)' : 'initial')};
  display: flex;
  font-size: var(--font-size-regular);
  font-weight: var(--font-weight-medium);
  justify-content: flex-end;
  line-height: var(--font-line-height-regular);
  min-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const SettlementsListAmountsWrapper = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &.attachments-modal-list-item {
    min-width: unset;
  }
`;

const SettlementsListActionButtonWrapper = styled.div`
  align-items: flex-end;
  display: flex;
  margin-left: 10px;

  span:not(.ant-btn-icon) {
    display: none;
  }

  @media ${windowMinWidth.laptopL} {
    margin-left: 20px;

    span:not(.ant-btn-icon) {
      display: flex;
    }
  }

  @media ${windowMaxWidth.mobile} {
    display: none;
  }
`;

const SettlementsListEmptyTextWrapper = styled.div`
  color: var(--greyscale-shade);
  font-size: var(--font-size-regular);
  line-height: var(--font-line-height-regular);
  padding: 0 30px;
`;

const SettlementsWorklistId = styled.div`
  display: block;
  font-size: var(--font-size-regular);
  font-weight: var(--font-weight-medium);
  justify-content: flex-start;
  line-height: var(--font-line-height-regular);
  max-width: 25ch;
  min-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media ${windowMaxWidth.mobile} {
    max-width: 20ch;
  }
`;

const SettlementsListHeaderWrapper = styled.div`
  background-color: var(--secondary-whisper);
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  padding-top: 10px;
  width: 100%;

  @media ${windowMaxWidth.mobile} {
    grid-template-columns: 1fr;
    gap: 5px;
  }
`;

const SettlementsTableCellWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const SettlementsTableCellWrapperSmallText = styled.div`
  color: ${(props) => (props.$isCanceled ? 'var(--greyscale-concrete)' : 'var(--greyscale-shade)')};
  display: flex;
  flex-direction: column;
  font-size: var(--font-size-small);
  line-height: var(--font-line-height-small);
`;

const SettlementsTableCellContentWrapperWithEllipsis = styled.div`
  color: ${(props) => (props.$isCanceled ? 'var(--greyscale-concrete)' : '')};
  max-width: 20ch;
  overflow: hidden;
  text-decoration: ${(props) => (props.$isCanceled ? 'line-through' : 'none')};
  text-overflow: ellipsis;
  white-space: nowrap;

  @media ${windowMinWidth.mobile} {
    max-width: 30ch;
  }

  @media ${windowMinWidth.laptopM} {
    max-width: 40ch;
  }

  @media ${windowMinWidth.fullHD} {
    max-width: 50ch;
  }
`;

const SettlementsTableCellContentWrapper = styled.div`
  color: ${(props) => (props.$isCanceled ? 'var(--greyscale-concrete)' : '')};
  text-decoration: ${(props) => (props.$isCanceled ? 'line-through' : 'none')};
`;

const SettlementsTableCellContentWrapperSettlementAmount = styled.div`
  color: ${(props) => (props.$isCanceled ? 'var(--greyscale-concrete)' : '')};
`;

const SettlementsTableCellStatusWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const SettlementsListLayout = {
  SettlementsWrapper,
  SettlementsListWrapper,
  SettlementsListItemVerticalSectionWrapper,
  SettlementsListItemHorizontalSectionWrapper,
  SettlementsListSmallSizeGreyTextWrapper,
  SettlementsListNormalSizeBoldTextWrapper,
  SettlementsListAmountsWrapper,
  SettlementsListActionButtonWrapper,
  SettlementsListEmptyTextWrapper,
  SettlementsWorklistId,
  SettlementsListHeaderWrapper,
  SettlementsTableCellWrapper,
  SettlementsTableCellWrapperSmallText,
  SettlementsTableCellContentWrapper,
  SettlementsTableCellContentWrapperWithEllipsis,
  SettlementsTableCellContentWrapperSettlementAmount,
  SettlementsTableCellStatusWrapper
};

export default SettlementsListLayout;
